import axios from "axios";

const envUrl = import.meta.env?.VITE_API_BASE_URL;
const host = typeof window !== "undefined" ? window.location.hostname : "";
const isProdHost = /(^|\.)kalisistemas\.com\.br$/.test(host);
const baseURL = isProdHost
  ? "https://api.kalisistemas.com.br/api"
  : envUrl || "http://127.0.0.1:8000/api";

const api = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 15000,
});

// Helper to set/remove token globally
export function setAuthToken(token) {
  if (token) {
    localStorage.setItem("auth_token", token);
    api.defaults.headers.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem("auth_token");
    delete api.defaults.headers.Authorization;
  }
}

// Attach token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle common errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 419) {
      // Token invalid/expired
      setAuthToken(null);
      // Optionally redirect to login route if you add one:
      // window.location.href = '/login'
    }
    return Promise.reject(error);
  },
);

export default api;
